module.exports = __webpack_public_path__ + "static/media/send_success.5504053a.svg";